/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2025-06-05 09:46:58
 * @LastEditors: linxi
 * @LastEditTime: 2025-08-06 16:15:55
 */
import React, { ReactElement, useRef, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { TabBar, TabPane } from '../../compnents/widgets/TabBar'
import { MERecordList } from './MERecord/MERecord'
import { PEIManagementList } from './PEIManagement/PEIManagement'
import { TIManagementList } from './TIManagement/TIManagement'
import { TrainingRecordList } from './TrainingRecord/TrainingRecord'

export const StaffRecordTabs = (): ReactElement => {
  const location: any = useLocation()

  const [selectKey, setSelectKey] = useState<any>('0')

  return (
    <TabBar
      style={{ margin: '10px 20px' }}
      defaultActiveKey={
        location.state ? location.state.selectKey : selectKey || '0'
      }
      onChange={(v) => {
        setSelectKey(v)
      }}
    >
      <TabPane key='0' tab='体检信息管理'>
        <PEIManagementList selectKey={selectKey} />
      </TabPane>
      <TabPane key='1' tab='培训信息管理'>
        <TIManagementList selectKey={selectKey} />
      </TabPane>
      <TabPane key='2' tab='体检记录'>
        <MERecordList selectKey={selectKey} />
      </TabPane>
      <TabPane key='3' tab='培训记录'>
        <TrainingRecordList selectKey={selectKey} />
      </TabPane>
    </TabBar>
  )
}
